
    import { defineComponent } from 'vue'
    import { iTargetDefinition } from './TargetDefinition'
    import { formatDate } from '@/helpers/commons/localeHelper'
    import targetDefinitionDecriptor from './TargetDefinitionDescriptor.json'
    import KnFabButton from '@/components/UI/KnFabButton.vue'
    import Listbox from 'primevue/listbox'
    import { AxiosResponse } from 'axios'

    export default defineComponent({
        name: 'target-definition',
        components: { KnFabButton, Listbox },
        data() {
            return {
                targetList: [] as iTargetDefinition[],
                loading: false,
                touched: false,
                targetDefinitionDecriptor: targetDefinitionDecriptor,
                formatDate: formatDate
            }
        },
        async created() {
            await this.loadAllMetadata()
        },
        methods: {
            async loadAllMetadata() {
                this.loading = true
                await this.$http
                    .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/kpiee/listTarget')
                    .then(
                        (response: AxiosResponse<any>) =>
                            (this.targetList = response.data.map((target: any) => {
                                return {
                                    id: target.id,
                                    name: target.name,
                                    startValidity: new Date(target.startValidity),
                                    endValidity: new Date(target.endValidity),
                                    author: target.author,
                                    values: target.values,
                                    category: target.category
                                }
                            }))
                    )
                    .finally(() => (this.loading = false))
            },
            showForm(target: any, clone: Boolean) {
                const path = target ? `/target-definition/edit?id=${target.id}&clone=${clone}` : '/target-definition/new-target-definition'
                if (!this.touched) {
                    this.$router.push(path)
                } else {
                    this.$confirm.require({
                        message: this.$t('common.toast.unsavedChangesMessage'),
                        header: this.$t('common.toast.unsavedChangesHeader'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.touched = false
                            this.$router.push(path)
                        }
                    })
                }
            },
            deleteTargetConfirm(targetId: number) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.deleteTarget(targetId)
                })
            },
            async deleteTarget(targetId: number) {
                await this.$http.delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/kpiee/' + targetId + '/deleteTarget').then(() => {
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.deleteTitle'),
                        msg: this.$t('common.toast.deleteSuccess')
                    })
                    this.closeForm()
                    this.loadAllMetadata()
                })
            },
            cloneTargetConfirm(target: any) {
                this.$confirm.require({
                    header: this.$t('common.toast.cloneConfirmTitle'),
                    accept: () => this.showForm(target, true)
                })
            },
            closeForm() {
                if (!this.touched) {
                    this.handleClose()
                } else {
                    this.$confirm.require({
                        message: this.$t('common.toast.unsavedChangesMessage'),
                        header: this.$t('common.toast.unsavedChangesHeader'),
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.touched = false
                            this.handleClose()
                        }
                    })
                }
            },
            handleClose() {
                this.$router.replace('/target-definition')
            },
            reloadMetadata(id) {
                this.$router.replace(`/target-definition/edit?id=${id}&clone=${false}`)
                this.touched = false
                this.loadAllMetadata()
            }
        }
    })
